













import { defineComponent, ref, watch, nextTick, computed } from '@vue/composition-api';

import AgreementCheckbox, { AgreementComponent } from '@/renderer/components/Base/Agreement/AgreementCheckbox.vue';

import { CONSTANT_URL } from '@/renderer/scripts/http';
import i18n from '@/locales/i18n';
import { getWeComAndWeChatLanguage } from '@/renderer/scripts/utils/tools';
import { encodeText } from '@/renderer/scripts/utils/tools/packages/encrypt';

export default defineComponent({
  props: {
    show: Boolean,
    isOauth: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AgreementCheckbox,
  },
  setup(props, context) {
    const vm = context.root;
    const store = vm.$store;
    const step = ref('scan');
    const wxLogin = ref(null);
    const agreementRef = ref<AgreementComponent | null>(null);
    const loading = computed(() => !store.getters.approvedAgreement);

    // 只能配置一个固定域名，非线上环境使用重定向的方式
    const { currentDomain, defaultDomain, officialWebsiteUrl, wechatQrcodeCss } = CONSTANT_URL;
    const domain = currentDomain === defaultDomain ? '' : `https://${currentDomain}`;
    let path = store.getters.isBrowser ? `${window.location.pathname}${window.location.search}` : '';
    // 对path进行先加密再2次encodeURI
    if (path) {
      path = encodeURIComponent(encodeURIComponent(encodeText(path)));
    }
    const redirectUrl = encodeURIComponent(`${officialWebsiteUrl}/login?domain=${domain}&path=${path}`);
    const methods = {
      // 渲染微信二维码
      async renderWeChatCode() {
        if (wxLogin.value) return;
        const { app_id, redirect_uri, scope, response_type, state, oauth_state, channel_flag } = vm.$route.query;
        const auth2_state = oauth_state || state;
        const wxRedirectUrl = props.isOauth
          ? encodeURIComponent(
              `${officialWebsiteUrl}/login?domain=${domain}&path=${path}&app_id=${app_id}&redirect_uri=${redirect_uri}&auth2_state=${auth2_state}&channel_flag=${channel_flag}&scope=${scope}&response_type=${response_type}`,
            )
          : redirectUrl;
        // 使用wxlogin_来判断是微信登录的回调
        // const state = await encodeText(`wxlogin_${new Date().getTime()}`);
        const wxState = `wxlogin_${new Date().getTime()}`;

        // @ts-ignore
        wxLogin.value = new WxLogin({
          self_redirect: false,
          id: 'wx_login',
          appid: 'wxf945d0734f7191ab',
          scope: 'snsapi_login',
          redirect_uri: wxRedirectUrl,
          state: wxState,
          href: `${wechatQrcodeCss}`, // 覆盖二维码样式需要引入自己的css
          lang: getWeComAndWeChatLanguage(i18n.locale),
        });
      },
      checkApproval() {
        agreementRef.value?.validate();
      },
      renderCodeEntrance() {
        nextTick(() => {
          methods.renderWeChatCode();
        });
      },
      validate() {
        return agreementRef.value?.validate();
      },
    };

    if (!loading.value) {
      methods.renderCodeEntrance();
    }

    watch(loading, val => {
      if (!val) {
        methods.renderCodeEntrance();
      }
    });

    return {
      step,
      agreementRef,
      loading,
      ...methods,
    };
  },
});
